import React, { useEffect } from 'react'

import { connect } from 'react-redux'

import SelectSearchContainer from '../SelectSearchContainer'
import Loading from '../Loading'

import { getBrokeragesIsLoading, getFilteredBrokerages } from './selectors'
import { fetchBrokerages } from '../../../brokerages/actions'

export const BrokerageSelectSearchContainer = (props) => {
  const {
    isLoading,
    brokerages,
    fetchBrokerages,
    value,
    onChange,
    id = 'brokerage-select-search-container'
  } = props

  useEffect(() => {
    // If brokerages are not already being loaded and there are no
    // brokerages in state, then go fetch the brokerages ourselves.
    if (!isLoading && brokerages.length <= 0) {
      fetchBrokerages()
    }
  }, [])

  if (isLoading) return <Loading width="36px" height="36px" />
  const brokerOptions = brokerages.map(broker => {
    const city = broker.city || ''
    const state = broker.state || ''
    const location = [city, state].filter(Boolean).join(', ')
    const alreadyHasLocation = location &&
      (!city || broker.name.includes(city)) &&
      (!state || broker.name.includes(state))
    const displayName = location && !alreadyHasLocation
      ? `${broker.name} - (${location})`
      : broker.name
    return {
      ...broker,
      displayLabel: `${broker.agencyCode} - ${displayName}`
    }
  })
  return (
    <SelectSearchContainer
      options={brokerOptions}
      value={value}
      onChange={onChange}
      id={id}
      labelColumn="displayLabel"
      valueColumn="brokerId"
    />
  )
}

const mapStateToProps = state => ({
  brokerages: getFilteredBrokerages(state),
  isLoading: getBrokeragesIsLoading(state),
})

const mapDispatchToProps = {
  fetchBrokerages,
}

export const ConnectedBrokerageSelectSearchContainer = connect(mapStateToProps, mapDispatchToProps)(BrokerageSelectSearchContainer)
